import React from 'react'
import ResponseFormListHeader from '../Component/ResponseForm/ResponseFormListHeader'
import ResponseFormList from "../Component/ResponseForm/ResponseFormList";

const ResponseFormPage = () => {
  return (
    <>
        <ResponseFormListHeader detailsFlag={false}/>
        <ResponseFormList />
    </>
  )
}

export default ResponseFormPage
